import React, { FC } from 'react';
import classNames from 'classnames';

import { DictionaryData, Trans } from 'app/lang';

import AmountBlock from './AmountBlock';

import styles from './TextWithAmountBar.module.scss';

// ---

type TextWithAmountBarProps = {
  value: number;
  label: DictionaryData;
  title?: string;
  className?: string;
  hasError?: boolean;
  onClick?: () => void;
  'data-test'?: string;
};

const TextWithAmountBar: FC<TextWithAmountBarProps> = ({
  label,
  value,
  title,
  className,
  hasError,
  onClick,
  ...props
}) => {
  const _className = classNames(styles.container, {
    [styles.error]: hasError,
  }, className);

  return (
    <div className={_className}
         data-test={classNames(props['data-test'], 'textWithAmountBar-container')}
         title={title}>
      <p data-test="textWithAmountBar-text"
         className={styles.text}>
        <Trans data={label}
               components={{
                 amount: (
                   <AmountBlock onClick={onClick}
                                value={value} />
                 ),
               }} />
      </p>
    </div>
  );
};

export default TextWithAmountBar;
